import { Badge } from "@musa.tech/design-system";
import { DEFAULT_INVOICE_STATUS, INVOICE_STATUS_CONFIG } from "./invoiceStatus";

interface InvoiceStatusBadgeProps {
  status: string;
}

export function InvoiceStatusBadge({ status }: InvoiceStatusBadgeProps) {
  const config = INVOICE_STATUS_CONFIG[status] ?? DEFAULT_INVOICE_STATUS;
  // `whitespace-nowrap`: a coluna de status é estreita e o rótulo de duas
  // palavras quebrava dentro da pílula, estourando a borda.
  return (
    <Badge variant={config.variant} className="whitespace-nowrap">
      {config.label}
    </Badge>
  );
}
